// extracted by mini-css-extract-plugin
export default {"card":"AntiSpam_card__bkXy7","content":"AntiSpam_content__ahTFo","marquee":"AntiSpam_marquee__AxMLT"};